import React from 'react';

import { Grid, Skeleton } from '@mui/material';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import { TablePagination } from '../../../../components/TablePagination';
import { Status } from '../../../../types/apiTypes';
import AdminUsersContainer from '../../AdminUsersContainer';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export interface UsersTablePaginationProps {}

const UsersTablePagination: React.FC<UsersTablePaginationProps> = () => {
    const { setPage, page, perPage, setPerPage, pagination, status, error } = useContainer(AdminUsersContainer);

    const onRowsPerPageChange = (newPerPage: number) => {
        setPerPage(newPerPage);
    };

    const onPageChange = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    if (error) return null;

    if (status === Status.InProgress) {
        return (
            <Grid container justifyContent="flex-end">
                <Skeleton width={400} height={50} />
            </Grid>
        );
    }

    if (!pagination) return null;

    return (
        <Container>
            <TablePagination
                count={pagination.total_records}
                page={page}
                rowsPerPage={perPage}
                onPageChange={onPageChange}
                onRowsPerPageChange={onRowsPerPageChange}
            />
        </Container>
    );
};

export default UsersTablePagination;
